'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports["default"] = formatEntry;

function formatEntry(_ref) {
  var _ref2 = _slicedToArray(_ref, 4);

  var word = _ref2[0];
  var partOfSpeech = _ref2[1];
  var translation = _ref2[2];
  var sound = _ref2[3];
  return {
    partOfSpeech: partOfSpeechMap[partOfSpeech],
    word: word,
    translation: translation,
    sound: sound
  };
}

var partOfSpeechMap = {
  v: {
    color: '#1779b1',
    ja: '動',
    en: 'verb'
  },
  n: {
    color: '#ff8b00',
    ja: '名',
    en: 'noun'
  },
  a: {
    color: '#6ba300',
    ja: '形',
    en: 'adjective'
  },
  r: {
    color: '#c0ae13',
    ja: '副',
    en: 'adverb'
  }
};